import authInstance from 'config/axios.config';

export const sellerServices = {
  getSellers: async (filters) => {
    const params = new URLSearchParams();

    Object.entries(filters).forEach(([key, value]) => {
      if (value && value !== 'all' && value !== '') {
        params.append(key, String(value));
      }
    });

    const res = await authInstance.get(`/admin/seller?${params}`);
    return res.data;
  },

  getSeller: async (sellerId) => {
    const res = await authInstance.get(`/admin/seller/${sellerId}`);
    return res.data;
  },

  updateSellerStatus: async (payload) => {
    const { sellerId, ...data } = payload;
    const res = await authInstance.patch(`/admin/seller/${sellerId}/status`, data);
    return res.data;
  },

  updateKycStatus: async (payload) => {
    const { sellerId, ...data } = payload;
    const res = await authInstance.patch(`/admin/seller/${sellerId}/kyc/status`, data);
    return res.data;
  },

  verifyKycDocument: async (payload) => {
    const { sellerId, documentId, ...data } = payload;
    const res = await authInstance.patch(`/admin/seller/${sellerId}/kyc/document/${documentId}`, data);
    return res.data;
  },

  updateBackgroundCheck: async (payload) => {
    const { sellerId, ...data } = payload;
    const res = await authInstance.patch(`/admin/seller/${sellerId}/kyc/background-check`, data);
    return res.data;
  },

  verifyBankDetails: async (payload) => {
    const { sellerId, ...data } = payload;
    const res = await authInstance.patch(`/admin/seller/${sellerId}/bank/verify`, {});
    return res.data;
  },

updateSellerProfile: async ({ sellerId, ...data }) => {
  const res = await authInstance.patch(
    `/admin/seller/${sellerId}/profile`,
    data
  );
  return res.data;
},

uploadFile: async (file) => {
  const formData = new FormData();

  formData.append('file', file);

  const res = await authInstance.post(
    '/admin/upload',
    formData,
    {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    }
  );

  return res.data;
},

// documentId: string | null — null means add mode, string means edit mode
upsertKycDocument: async (sellerId, documentId, payload) => {
  const url = documentId
    ? `/admin/seller/${sellerId}/kyc/${documentId}`
    : `/admin/seller/${sellerId}/kyc`;

  const res = await authInstance.put(url, { document: payload }); // ← wrap in document key
  return res.data;
},

deleteSeller: async (sellerId) => {
  const res = await authInstance.delete(`/admin/seller/${sellerId}`);
  return res.data;
},

exportSellers: async ({
  search,
  status,
  kycStatus,
  phoneVerified,
  emailVerified,
  categoryId,
  subcategoryId,
  sellerType,
  sortBy,
  order,
}) => {
  const params =
    new URLSearchParams({
      search: search || '',

      status:
        status === 'all'
          ? ''
          : status || '',

      kycStatus:
        kycStatus === 'all'
          ? ''
          : kycStatus || '',

      phoneVerified:
        phoneVerified === 'all'
          ? ''
          : phoneVerified || '',

      emailVerified:
        emailVerified === 'all'
          ? ''
          : emailVerified || '',

      categoryId:
        categoryId || '',

      subcategoryId:
        subcategoryId || '',

      sellerType:
        sellerType || '',

      sortBy:
        sortBy || 'createdAt',

      order:
        order || 'desc',
    });

  for (const [key, value] of [
    ...params.entries(),
  ]) {
    if (!value) {
      params.delete(key);
    }
  }

  return authInstance.get(
    `/admin/seller/export?${params.toString()}`,
    {
      responseType: 'blob',
    }
  );
},
};
